<template>
  <div class="heading-icon">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "HeadingIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.heading-icon {
  @include flex(flex, center, center, row, nowrap);
  text-align: center;
  @include mq-down(md) {
    margin-bottom: 12px;
    :deep(.icon-box) {
      margin-right: 12px;
    }
  }
  @include mq-up(md) {
    margin-bottom: 15px;
    :deep(.icon-box) {
      margin-right: 15px;
    }
  }
  > :deep(.heading) {
    @include mq-down(md) {
      font-size: 18px;
    }
    @include mq-up(md) {
      font-size: 24px;
    }
  }
  &.-primary {
    color: $primary;
  }
  &.-bold {
    :deep(.heading) {
      font-weight: bold;
    }
  }
  &.-left {
    @include flex(flex, flex-start, center, row, nowrap);
    text-align: left;
  }
}
</style>
